import cookie from 'js-cookie';
import i18n from 'i18next';
import { PRIVATIZATION } from '@meiqia/constants';
import { customizedLogout } from '@meiqia/utils';

const logout = () => {
  const basename = PRIVATIZATION.CUSTOMIZED_PATH;
  // server 中判断没有则跳转到登录页
  const ent_id = cookie.get('_enterprise_id');
  // 暂通过企业ID判断是否是顺丰去区分跳转 signin_shunfeng 和 signin_new
  const isShunFeng = ent_id === i18n.t('顺丰1') || ent_id === i18n.t('顺丰2');
  cookie.remove('_authenticated');
  cookie.remove('_enterprise_id');
  const isHide = localStorage.getItem('isHide') === 'true';
  window.onbeforeunload = function() {};
  if (PRIVATIZATION.CUSTOMIZED_LOGOUT_URL) {
    customizedLogout(PRIVATIZATION.CUSTOMIZED_LOGOUT_URL);
  } else {
    window.location.href = isHide
      ? isShunFeng
        ? `${basename}/signin_shunfeng`
        : `${basename}/signin_new`
      : `${basename}/signin`;
  }
};

export default logout;
